export const resourcesArticles = [
  {
    slug: "postpartum-in-the-bay",
    title: "Postpartum in the Bay: Where to Actually Get Support",
    excerpt:
      "From pelvic floor PT to village-style retreats, a practical guide for Bay Area moms in the fourth trimester.",
    body: [
      "The first months after birth can feel like a blur. In the Bay Area, there are more resources than most moms realize — but they can be hard to find when you’re sleep deprived.",
      "This guide maps out local support options from postnatal retreats to lactation consultants, so you can build a real village around you.",
    ],
    category: "Postpartum",
    tags: ["postpartum", "bay-area", "support"],
    author: "Heather Anderson",
    publishedAt: "2024-03-05",
    heroImage: "/images/resources/postpartum-bay.jpg",
    featured: true,
  },
  {
    slug: "raising-emotionally-healthy-boys",
    title: "Raising Emotionally Healthy Boys in a Perfectionist Culture",
    excerpt:
      "Tools for helping our sons feel their feelings, ask for help, and stay connected to themselves.",
    body: [
      "So many moms in The Mamahood talk about the pressure their boys feel to be ‘tough’ and ‘easy’.",
      "In this piece, we share scripts, therapist-backed strategies, and community stories for raising boys who can be both strong and soft.",
    ],
    category: "Parenting",
    tags: ["parenting", "emotional-health"],
    author: "The Mamahood Editorial Team",
    publishedAt: "2024-01-22",
    heroImage: "/images/resources/healthy-boys.jpg",
    featured: true,
  },
  {
    slug: "brightlife-kids-mental-health-support",
    title: "Free Mental Health Support for Kids: BrightLife Kids",
    excerpt:
      "A zero-cost resource helping California families access virtual mental health coaching for kids ages 0–12.",
    body: [
      "BrightLife Kids is one of the most frequently recommended resources inside The Mamahood.",
      "Here’s how to know if it’s a fit for your family, how to get started, and what other moms are saying.",
    ],
    category: "Mental Health",
    tags: ["mental-health", "kids", "bay-area"],
    author: "Guest Contributor",
    publishedAt: "2024-02-10",
    heroImage: "/images/resources/brightlife-kids.jpg",
    featured: true,
  },
  {
    slug: "mamahood-collective-for-founders",
    title: "The Mamahood Collective: Where Mom Founders Go to Grow",
    excerpt:
      "Inside look at the Collective: office hours, connections, and the real talk you can’t find on LinkedIn.",
    body: [
      "Building a business while raising kids is a lot. The Mamahood Collective was created to hold both.",
      "In this article we share stories from founders in the Collective and how they use the community to launch and grow.",
    ],
    category: "Money & Career",
    tags: ["entrepreneurship", "collective"],
    author: "Community Spotlight",
    publishedAt: "2024-04-18",
    heroImage: "/images/resources/collective-founders.jpg",
    featured: false,
  },
  {
    slug: "bay-area-weekend-with-kids",
    title: "A Low-Lift Bay Area Weekend with Kids",
    excerpt:
      "Three simple itineraries crowdsourced from The Mamahood: no overplanning, just real-life fun.",
    body: [
      "You don’t need a color-coded spreadsheet to have a magical weekend.",
      "We pulled together low-lift ideas from the community — from beach mornings to park picnics and ice cream spots — that work with nap schedules and real budgets.",
    ],
    category: "Lifestyle",
    tags: ["bay-area", "weekend", "lifestyle"],
    author: "The Mamahood Community",
    publishedAt: "2024-05-02",
    heroImage: "/images/resources/bay-weekend.jpg",
    featured: false,
  },
  {
    slug: "perimenopause-and-the-mamahood",
    title: "Perimenopause, Hormones, and the Moms No One Warned",
    excerpt:
      "Why so many of us are blindsided by perimenopause — and where to find real support in the Bay.",
    body: [
      "Many mothers in our community are navigating perimenopause while still in the thick of school pickups and bedtime battles.",
      "We highlight local practitioners, support groups, and questions to ask your provider so you don’t have to figure this out alone.",
    ],
    category: "Health & Wellness",
    tags: ["perimenopause", "health", "bay-area"],
    author: "Editorial Partner",
    publishedAt: "2024-06-07",
    heroImage: "/images/resources/perimenopause.jpg",
    featured: true,
  },
];

